<template>
  <div :id="id" :class="wrapperClasses">
    <div
      class="mx-auto w-full max-w-screen-2xl rounded-[30px] px-5 py-6 text-[color:var(--color-white)] md:px-12 md:py-14"
      :class="background ? background : 'bg-[color:var(--color-secondary-500)]'"
    >
      <div v-if="title" class="mb-12 text-center text-2xl font-bold lg:text-3xl">
        {{ title }}
      </div>
      <div v-if="subtitle" class="mb-8 text-center text-base">
        {{ subtitle }}
      </div>
      <div
        class="items-top grid grid-cols-1 gap-x-20 gap-y-10 px-8 lg:px-0"
        :class="columns && columns.length === 4 ? 'lg:grid-cols-4' : 'lg:grid-cols-3'"
      >
        <div v-for="(item, index) in columns" :key="index" class="text-center">
          <div class="mb-6 h-24 max-h-24 w-auto">
            <VcImage :src="item.image" class="feature-image mx-auto h-full" lazy />
          </div>
          <div v-if="item.title" class="mb-3 text-[22px] font-bold">
            {{ item.title }}
          </div>
          <div v-if="item.text">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

type ColumnsType = {
  title: string;
  text: string;
  image: string;
  alttext: string;
  icon: string;
};

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  title?: string;
  subtitle?: string;
  columns?: Array<ColumnsType>;
}

const props = defineProps<IProps>();

const wrapperClasses = computed(() => {
  return [props.textColor ? props.textColor : "text-white", "pb-10 lg:pb-24 mx-4"];
});
</script>

<style scoped lang="scss">
.vc-typography--variant--h1 {
  @apply normal-case;
}

.features-block {
  &.bg-neutral-800 {
    color: white;
  }
}
</style>
